import request from "../libs/request";
import { GetManagerReportDetailRequest } from "./mangerReportServices";

const baseUrl = "center/incommodity/user";

export const deleteReport = (params: GetManagerReportDetailRequest) =>
  request.delete(`${baseUrl}/${params.centerIncommodityId}`);

export type SatisfactionRequest = {
  satisfaction: number;
  comment: string;
  serviceType?: string; // #1444 이슈에서 불편신고 만족도 평가시에만 atg연동을 위해 추가 전달
};

export const postSatisfaction = (
  serviceId: number,
  params: SatisfactionRequest
) => request.post(`${baseUrl}/satisfaction/${serviceId}`, params);

export const getIncommodityVirtualNumber = (centerIncommodityId: number) =>
  request.get(`${baseUrl}/${centerIncommodityId}/creator/virtual-number`);
